/**
 * Analytics · Trend Analysis
 * Demo content - see src/demo/analytics.ts.
 */

import React from 'react';
import { AppShell } from '../../components/shell/AppShell';
import { Card, Kpi, PageHead, Table, Note, DemoBadge } from '../../components/ui';
import { ChartFrame, Trend, Sparkline } from '../../components/charts';
import { TRENDS } from '../../demo/analytics';

export const TrendAnalysisPage: React.FC = () => (
  <AppShell
    title="Trend Analysis"
    sub="Analytics"
    actions={
      <>
        <DemoBadge />
        <button className="btn btn-g">Last 6 months</button>
      </>
    }
  >
    <PageHead
      eyebrow="Analytics"
      title="What is moving, and since when"
      lede="Direction matters more than the level. Each metric is compared against its own history, so a change is reported when it leaves the normal range — not when it crosses a round number."
    />

    <div className="g g4" style={{ marginBottom: 12 }}>
      {TRENDS.kpis.map((k) => (
        <Kpi
          key={k.label}
          label={k.label}
          value={k.value}
          color={k.color}
          icon={k.icon as any}
          sub={'sub' in k ? (k as any).sub : undefined}
        />
      ))}
    </div>

    <div className="g g3" style={{ marginBottom: 12 }}>
      <div className="s2">
        <ChartFrame title="Gross margin" sub="monthly, % — GM-01">
          <Trend data={TRENDS.marginVsFreight} x="month" series={[{ key: 'margin', label: 'Gross margin %' }]} unit="%" />
        </ChartFrame>
      </div>
      <ChartFrame title="Inbound freight per unit" sub="monthly, $">
        <Trend data={TRENDS.marginVsFreight} x="month" series={[{ key: 'freight', label: 'Freight $/unit' }]} />
      </ChartFrame>
    </div>

    <Card title="Every tracked metric" sub="change measured against the metric's own range" flush>
      <Table
        cols={[
          { t: 'Metric' },
          { t: 'Now', num: true },
          { t: 'Was', num: true },
          { t: 'Change', num: true },
          { t: 'Trend' },
          { t: 'Since' },
          { t: 'Reading' },
        ]}
        rows={TRENDS.rows.map((r) => [
          <b>{r.metric}</b>,
          r.now,
          <span className="dim">{r.prior}</span>,
          <span style={{ fontWeight: 700 }}>
            {r.dir === 'up' ? '▲' : '▼'} {Math.abs(r.change)}%
          </span>,
          <Sparkline data={r.spark as unknown as number[]} />,
          <span className="dim">{r.since}</span>,
          <span className="dim">{r.note}</span>,
        ])}
      />
    </Card>

    <Note style={{ marginTop: 12 }}>
      <b>Two of these move together.</b> Freight per unit and gross margin have tracked inversely for
      five months — freight explains roughly a third of the margin decline, discounting explains the
      rest.
    </Note>
  </AppShell>
);
